let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2O2ui")).then(() => parcelRequire('dIaAd'));